<script>
  import { Bar } from 'vue-chartjs'

  export default {
    extends: Bar,
    props: ['labels', 'dataset'],
    watch: { 
      labels: function(labels) {
        this.renderChart(this.data, this.options);
      }
    },
    computed: {
      options: function() {
        return {
          maintainAspectRatio: false,
          layout: {
            padding: {
              right: 15,
              top: 20
            }
          },
          tooltips: {
            titleFontSize: 16,
            bodyFontSize: 14,
            displayColors: false,
            xPadding: 10,
            yPadding: 10,
            callbacks: {
              label: function(tooltipItem, data) 
              { 
                var label = data.datasets[tooltipItem.datasetIndex].label+': ' || '';
                return label+tooltipItem.yLabel+'%';
              }
            }
          },
          legend:
          {
            display: false,
            labels:
            {
              display: false
            }
          },
          scales:
          {
            yAxes: [
            {
              stacked: true,
              gridLines:
              {
                display: true,
                color: "#e6e6e6",
                borderDash: [2, 2],
                lineWidth: 2,
                drawBorder: false,
              },
              ticks:
              {
                beginAtZero: true,
                fontSize: 14,
                fontColor: '#B5B5B5',
                display: false,
                max: 120
              }
            }],
            xAxes: [
            {
              // categoryPercentage: this.data.labels.length > 12 ? 0.7 : 0.4,
              stacked: true,
              gridLines:
              {
                display: true,
                color: "#e6e6e6",
                borderDash: [2, 2],
                lineWidth: 2,
                drawBorder: false,
            },
              ticks:
              {
                beginAtZero: true,
                fontSize: 14,
                maxRotation: 0,
                minRotation: 0,
                fontColor: '#B5B5B5',
              }
            }]
          },
          chartArea: {
            backgroundColor: 'rgba(251, 85, 85, 0.4)'
          }
        };
      },
      data: function() {
        return {
          labels: this.labels,
          datasets: [
            {
              label: "Время работы",
              backgroundColor: '#886AB5',
              data: this.dataset.up
            },
            {
              label: "Время простоя",
              backgroundColor: '#FD3995',
              data: this.dataset.down
            }
          ]
        };
      }
    },
    mounted () {
      this.renderChart(this.data, this.options)
    }
  }
</script>